.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.options {
  display: flex;
  flex-direction: column;
}

.options[data-orientation='horizontal'] {
  flex-flow: row wrap;
  column-gap: var(--space-5);
}

/* 44px rows so options are easy to hit on touch screens (DESIGN.md §10). */
.radio {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: var(--row-height);
  color: var(--ink);
  font: var(--t-body);
  cursor: pointer;
}

.circle {
  flex: none;
  width: 20px;
  height: 20px;
  border: 1px solid var(--border-strong);
  border-radius: 50%;
  background: var(--paper);
  transition: border-width var(--dur) var(--ease);
}

.radio[data-selected] .circle {
  border-width: 6px;
  border-color: var(--brand);
}

.radio[data-focus-visible] .circle {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.radio[data-disabled] {
  color: var(--pencil);
  cursor: not-allowed;
}

.radio[data-disabled] .circle {
  border-color: var(--rule);
  background: var(--wash);
}

.option {
  display: flex;
  flex-direction: column;
}

.optionDescription {
  margin-top: calc(-1 * var(--space-2));
  padding-left: calc(20px + var(--space-3));
  color: var(--graphite);
  font: var(--t-small);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}
